




































import { defineComponent, ref, computed } from "@vue/composition-api";
import useUserSettings from "@/store/useUserSettings";
import UserSettingsViewModel from "@/models/UserSettingsViewModel";

export default defineComponent({
    name: "EditNicknameDialog",
    components: {
        ConfirmDialog: () =>
            import(/* webpackChunkName: "settings" */ "../Dialogs/ConfirmDialog.vue")
    },
    props: {
        value: { type: Boolean, default: false }
    },
    setup(props, context) {
        const { getUserSettings, updateUserSettings } = useUserSettings();
        const showSuccess = ref<boolean>(false);
        const model = ref<UserSettingsViewModel>();

        const initSave = () => {
            updateUserSettings(model.value).then(() => {
                showSuccess.value = true;
                close();
                context.emit("input", false);
                context.emit("OnSaveNickname", model.value);
            });
        };

        const close = () => {
            context.emit("input", false);
            context.emit("OnCancel");
        };

        getUserSettings().then((value: UserSettingsViewModel) => {
            model.value = value;
        });

        return {
            close,
            model,
            showSuccess,
            initSave,
        };
    }
});
